import React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

const Footer = () => (
  <footer className="footer">
    <div className="footer__copyRight">
      <FormattedMessage id="copyRight" />
      <FormattedDate value={Date.now()} year="numeric" />
    </div>
    <FormattedMessage
      id="login.contactUs"
      values={{
        p: (...chunks) => <p className="footer__contactUs">{chunks}</p>,
        bold: (chunks) => <b>{chunks}</b>,
        link: (chunks) => (
          <a
            href="mailto:support@openforestprotocol.org"
            className="footer__contactUsEmail"
          >
            {chunks}
          </a>
        ),
      }}
    />
  </footer>
);

export default Footer;
